import React from "react";
import { userHasAnyRole } from "../../../utils/SecurityUtils";
import { BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBD } from "../../../consts/funktionaleRollen";

function Wasserversorgung(props) {
    function isDisabled() {
        if (props.anlegen) return false;
        if (props.modus === "l") {
            return true;
        }
        if (props.modus === "s") {
            return !userHasAnyRole([FACHADMIN, SYSTEMADMIN, ZUST_SBD, BETREIBER]);
        }
        return true;
    }

    return (
        <div className="gridl gridForWasserversorgungen tabsheet-content-margin">
            {props.formFactory.renderCheckbox(
                "wasserversorgung.oeffentlWasserversorgung",
                "wasserversorgung.oeffentlWasserversorgung",
                "öffentliche Wasserversorgung",
                isDisabled()
            )}
            {props.formFactory.renderNumberInput(
                "wasserversorgung.wasserbezug",
                "wasserversorgung.wasserbezug",
                "Wasserbezug",
                isDisabled()
            )}
            {props.formFactory.renderInput(
                "wasserversorgung.bezugsjahrWv",
                "wasserversorgung.bezugsjahrWv",
                "Bezugsjahr",
                "text",
                isDisabled()
            )}
            {props.formFactory.renderCheckbox(
                "wasserversorgung.eigenversorgung",
                "wasserversorgung.eigenversorgung",
                "betriebliche Eigenversorgung",
                isDisabled()
            )}
            {props.formFactory.renderInput("wasserversorgung.wvbNr", "wasserversorgung.wvbNr", "WVB-Nr.", "text", isDisabled())}
            {props.formFactory.renderCheckbox(
                "wasserversorgung.betriebInSchutzgebiet",
                "wasserversorgung.betriebInSchutzgebiet",
                "Betrieb In Schutzgebiet",
                isDisabled()
            )}
        </div>
    );
}

export default Wasserversorgung;
